<template>
  <WarRoomCommissionEarnBannerCard>
    <div slot="header" class="war-room-commission-earn-banner-more-ways__header">
      More ways to Earn Commission
      <CloseIcon class="war-room-commission-earn-banner-more-ways__icon" @click="handleClose" />
    </div>
    <div slot="content" class="war-room-commission-earn-banner-more-ways__content">
      <ul class="war-room-commission-earn-banner-more-ways__list">
        <li class="war-room-commission-earn-banner-more-ways__list-item">Participate in monthly War Room contests.</li>
        <li class="war-room-commission-earn-banner-more-ways__list-item">
          Get your comments and posts upvoted. One upvote is
          <WarRoomCommissionEarnBannerPoint :count="1" class="war-room-commission-earn-banner-more-ways__points" />
          .
        </li>
        <li class="war-room-commission-earn-banner-more-ways__list-item">Earn commission by voting in polls!</li>
      </ul>
    </div>
  </WarRoomCommissionEarnBannerCard>
</template>

<script>
import WarRoomCommissionEarnBannerCard from '@/components/partials/war-room/WarRoomCommissionEarnBanner/WarRoomCommissionEarnBannerCard';
import CloseIcon from '@/assets/svg/close.vue.svg';
import WarRoomCommissionEarnBannerPoint from '@/components/partials/war-room/WarRoomCommissionEarnBanner/WarRoomCommissionEarnBannerPoint';
import { commissionBannerTooltipName } from '@/components/partials/war-room/WarRoomCommissionEarnBanner/constants';

export default {
  name: 'WarRoomCommissionEarnBannerMoreWays',
  components: {
    WarRoomCommissionEarnBannerCard,
    CloseIcon,
    WarRoomCommissionEarnBannerPoint,
  },
  methods: {
    handleClose() {
      this.$tooltip.close(commissionBannerTooltipName);
    },
  },
};
</script>

<style scoped lang="scss">
.war-room-commission-earn-banner-more-ways {
  color: var(--theme-color-sub-text);

  &__header {
    height: 36px;
    color: var(--blue-60);
    background: var(--blue-60-a20);

    @include subhead-semibold;

    padding: 0 8px 0 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__icon {
    color: var(--blue-60);
    margin-left: 4px;
    cursor: pointer;
    width: 20px;
    height: 20px;
    transition: color 0.3s;

    &:hover {
      color: var(--blue-50);
    }
  }

  &__content {
    color: var(--theme-color-sub-text);
  }

  &__points {
    display: inline-block;
    vertical-align: middle;
  }

  &__list {
    padding: 0;
    margin: 0 0 0 16px;

    @include subhead;

    color: inherit;
  }

  &__list-item {
    @include inherit-font;

    margin-bottom: 11px;

    &:last-of-type {
      margin-bottom: 0;
    }
  }
}
</style>
